import React from 'react'
import ChannelsTemporal from '../channels-temporal'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import reducer from './reducer'
import {
    TemporalEvent,
    TemporalState,
    TemporalWidget,
    TemporalWidgetConfig
} from 'plugin-liverig-vis/js/widget-types/channels-temporal/v2/types'
import { withSuspenseWrapper } from 'plugin-liverig-vis/js/components/SuspenseWrapper'

const NextGen = reactWidgetWrapper<TemporalState, FlowMessage<LiveEvent<TemporalEvent>>, TemporalWidget>(
    withSuspenseWrapper(React.lazy(() => import('./Chart'))),
    reducer
)

/**
 * Check if this widget configuration require any addons.
 * @param cfg
 */
function requireAddon(cfg: TemporalWidgetConfig): boolean {
    if (Array.isArray(cfg.addons) && cfg.addons.length > 0) {
        return true
    } else if (typeof cfg.addons === 'object' && Object.values(cfg.addons).length > 0) {
        return true
    }

    return false
}

type Options = Record<string, unknown> | LiveWidgetImplOptions<TemporalWidgetConfig>

export default function (options: Options = {}): unknown {
    if (requireAddon(options.cfg as TemporalWidgetConfig)) {
        // don't use next-gen on charts with any addon; isn't supported yet!
        // The ChannelsTemporal constructor is implemented on Live Temporal
        // and it expects one argument, but typescript has an issue with that,
        // and it could be because we are not exporting getAssetChartPrototype
        // as a typescript module
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return new ChannelsTemporal(options)
    }

    return new NextGen(options as LiveWidgetImplOptions)
}
